import { FolderOpen, Pencil, Trash2 } from "lucide-react";
import defaultAvatar from "../../assets/logo/logo.png";
import { resolveMedia } from "../../services/api";

export default function AdminRow({ admin, onView, onEdit, onDelete }) {
  const avatar = resolveMedia(admin?.profilPicture, defaultAvatar);

  return (
    <tr>
      <td>
        <div className="userCell">
          <img src={avatar} alt="avatar" className="tableAvatar" />
          <div>
            <div className="userName">
              {admin.firstName} {admin.lastName}
            </div>
            <div className="userSub">{admin.contact?.email}</div>
          </div>
        </div>
      </td>

      <td>{admin.contact?.tel || "-"}</td>

      <td>
        <span className="roleBadge">{admin.username || "-"}</span>
      </td>

      <td className="center">
        <div className="actions">
          <button
            type="button"
            className="iconBtn"
            title="Voir détails"
            onClick={() => onView?.(admin)}
          >
            <FolderOpen size={18} />
          </button>

          <button
            type="button"
            className="iconBtn edit"
            title="Modifier"
            onClick={() => onEdit?.(admin)}
          >
            <Pencil size={18} />
          </button>

          <button
            className="iconBtn danger"
            title="Supprimer"
            onClick={() => onDelete?.(admin)}
          >
            <Trash2 size={16} />
          </button>
        </div>
      </td>
    </tr>
  );
}
